"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _reactRedux = require("react-redux");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Reservation = require("../components/Reservation");

var _Reservation2 = _interopRequireDefault(_Reservation);

var _initialization = require("../actions/initialization");

var _form = require("../actions/form");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function mapDispatchToProps(dispatch) {
  return {
    initialize: function initialize(formData, formSteps, configId) {
      return Promise.all([dispatch((0, _initialization.initialize)(configId)), dispatch((0, _form.configure)(formSteps, formSteps, formData))]);
    }
  };
}

function mapStateToProps(state) {
  var _state$form = state.form,
      currentStep = _state$form.currentStep,
      finishedSteps = _state$form.finishedSteps,
      steps = _state$form.steps,
      hasSubmitted = _state$form.hasSubmitted,
      isSubmitting = _state$form.isSubmitting;
  return {
    currentStep: currentStep,
    progress: finishedSteps.length / steps.length * 100,
    hasSubmitted: hasSubmitted,
    isSubmitting: isSubmitting
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps, {
    initialize: function initialize() {
      return dispatchProps.initialize(ownProps.initialData, ownProps.steps, ownProps.configId);
    }
  });
}

var ReservationContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(_Reservation2.default);
ReservationContainer.propTypes = {
  initialData: _propTypes2.default.object,
  steps: _propTypes2.default.array,
  configId: _propTypes2.default.string.isRequired,
  onBookingSuccess: _propTypes2.default.func
};
ReservationContainer.defaultProps = {
  initialData: {},
  steps: ["service", "timeslot", "mobility", "vehicle", "customer"],
  onBookingSuccess: function onBookingSuccess() {}
};
exports.default = ReservationContainer;